<template>
  <form @submit.prevent>
    <!-- Veri kartı envanter paneli "İdari / Teknik Tedbirler" bölümünün kendi formu: yalnız iki tedbir listesi.
         TKP-162: liste tedbir kütüphanesinden (kategori + ürün süzülmüş); "+ Yeni tedbir ekle" ad girip kütüphaneye yazar
         (kategori bölümden, ürün mevcut üründen; TKP-136 kapısı: yetkisize 403) ve seçime ekler. -->
    <h4 class="mb-1">{{ $t("inventory.node-form.measures-title") }}</h4>
    <!-- TKP-182 md.81: paneller hedef veri adlarını kendileri listeler (çoklu seçimde yalnız ilk ad yazıyordu) -->
    <p v-if="!hideTarget" class="text-muted small">{{ node && node.data && node.data.name | translate }}</p>
    <p v-if="prepareMode" class="text-muted small" data-test="measures-prepare-hint">{{ $t("inventory.hierarchy.measures-prepare-hint") }}</p>

    <div v-for="section in sections" :key="section.category">
      <h6 class="mt-3">{{ $t(section.label) }}</h6>
      <filter-select :id="section.category + 'MeasureFilter'" :ref="section.category + 'MeasureFilter'" :placeholder="$t('measure.text')" :multiple="true" @filter="(v, cb) => onMeasureSearch(section.category, v, cb)" :selected="form[section.field]" @changed="(v) => (form[section.field] = v || [])" />
      <div v-if="adding === section.category" class="mt-1 d-flex align-items-center" :data-test="'measure-add-' + section.category">
        <input class="form-control form-control-sm mr-2" v-model="newName" :placeholder="$t('measure.add-placeholder')" data-test="measure-add-name" @keyup.enter="quickAdd(section)" />
        <button class="btn btn-sm btn-success mr-1" :disabled="!newName.trim() || quickAdding" data-test="measure-add-save" @click="quickAdd(section)">{{ $t("measure.add") }}</button>
        <button class="btn btn-sm btn-secondary" data-test="measure-add-cancel" @click="adding = null">{{ $t("common.cancel") }}</button>
      </div>
      <span v-else class="text-primary hand small" :data-test="'measure-add-new-' + section.category" @click="startAdd(section.category)">{{ $t("measure.add-new") }}</span>
    </div>

    <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-3" data-test="save-measures">
      {{ $t("common.save") }}
    </sweet-button>
  </form>
</template>

<script>
import rest from "@/rest-client";
import { addToSelection, measureSearchQuery } from "@/modules/measure/measure";
import { measuresPayload } from "./node-measures";

const SECTIONS = [
  { category: "ADMINISTRATIVE", field: "administrativeMeasures", label: "inventory.node-form.administrative-measures" },
  { category: "TECHNICAL", field: "technicalMeasures", label: "inventory.node-form.technical-measures" },
];

export default {
  // TKP-177 md.52: prepareMode — kaydetmez, seçimi `onPrepared` ile verir (birim/süreç panelinde seçili her düğüme ayrı yazılır)
  props: ["id", "node", "prepareMode", "hideTarget"],
  data() {
    return { form: this.formOf(this.node), sections: SECTIONS, adding: null, newName: "", quickAdding: false };
  },
  computed: {
    isUpdating() {
      return this.$store.getters["organizationProcessData/isUpdating"];
    },
  },
  watch: {
    node: {
      deep: true,
      handler(v) {
        this.form = this.formOf(v);
      },
    },
  },
  methods: {
    formOf(node) {
      return { administrativeMeasures: node?.administrativeMeasures ?? [], technicalMeasures: node?.technicalMeasures ?? [] };
    },
    /** TKP-162: tedbir kütüphanesi — bölümün kategorisi + mevcut ürün + ad araması. */
    async onMeasureSearch(category, value, callback) {
      const response = await this.$store.dispatch("measure/paginateForSearch", { options: { limit: 50 }, query: measureSearchQuery(category, this.currentProduct, value) });
      callback(response.data?.docs ?? []);
    },
    startAdd(category) {
      this.adding = category;
      this.newName = "";
    },
    async quickAdd(section) {
      const name = this.newName.trim();
      if (!name || this.quickAdding) return;
      this.quickAdding = true;
      try {
        const { data } = await rest.post("/library/measure/quick", { name, category: section.category, product: this.currentProduct });
        this.form[section.field] = addToSelection(this.form[section.field], data);
        this.adding = null;
        this.newName = "";
        this.$toast.success(this.$t("measure.added"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        this.quickAdding = false;
      }
    },
    async save() {
      if (this.prepareMode) {
        this.$emit("onPrepared", { administrativeMeasures: [...this.form.administrativeMeasures], technicalMeasures: [...this.form.technicalMeasures] });
        this.$root.$emit("bv::toggle::collapse", this.id);
        return;
      }
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) return;
      try {
        // yalnız tedbir alanları gider; kaynaklar/kategori/not bu formda değişmez (backend mevcut değerlerle birleştirir)
        await this.$store.dispatch("organizationProcessData/update", measuresPayload(this.node, this.form));
        this.$toast.success(this.$t("common.success"));
        this.$emit("onSaved");
        this.$root.$emit("bv::toggle::collapse", this.id);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
  },
};
</script>
